import { checkExtension, ExtensionMetadata, ExtensionType, Loader, LoaderParser, LoaderParserPriority, ResolvedAsset } from "pixi.js";
import { PromiseCompletionSource } from "scene-manager";
import { SRGBColorSpace, Texture, TextureLoader } from "three";

export class ThreeJSTextureLoader implements LoaderParser<Texture> {

    public readonly name: string;
    public readonly extension: ExtensionMetadata;

    private readonly loader: TextureLoader;

    public constructor() {
        this.name = `three_texture_loader`;
        this.extension = {
            type: ExtensionType.LoadParser,
            priority: LoaderParserPriority.High
        };
        this.loader = new TextureLoader();
    }

    public test(url: string): boolean {
        return checkExtension(url, [".thpng", ".thjpg"]);
    }

    public async load<T>(url: string, _resolvedAsset?: ResolvedAsset<Record<string, any>>, _loader?: Loader): Promise<T> {
        const pcs = new PromiseCompletionSource<Texture>();
        this.loader.load(
            url,
            (result: Texture) => {
                result.colorSpace = SRGBColorSpace;
                pcs.complete(result);
            },
            null,
            (reason: unknown) => pcs.error(reason)
        );
        const result = await pcs.result as T;
        return result;
    }

}
